export default {
  namespaced: true,

  state: {
    currentStep: 1,
    reachedStep: 1,
    os: true,
    changeLicence: null,
    osOldPrice: null,
    osPrice: null,
    discounts: [],
    discount: null,
    discountRecommendation: null,
    discountFromRecommendationSet: true,
    walletBalance: 0,
    cartProducts: [],
    cartCloud: [],
    cloudPlan: null,
    cloudMonths: [],
    licenceData: {
      NIP: '',
      NAG: '',
      N1: '',
      N2: '',
      AD: '',
      KOD: '',
      MI: '',
      TEL1: '',
      TEL2: '',
      E1: '',
      O1: '',
      SIE: '',
    },
    version: ['e-aktu'],
    payment: 'payu',
    delivery: null,
    invoiceData: {
      nip: '',
      name1: '',
      name2: '',
      address: '',
      postalCode: '',
      city: '',
    },
    correspondenceData: {
      AKN: '',
      AKA: '',
      AKM: '',
    },
    showInvoice: false,
    AKL: false,
    policy: false,
    totalGross: 0,
    totalNet: 0,
    file: null,
    orderBy: null,
    orderSource: 'te',
    quantity: 1,
    freeCloudUsed: false,
    currentCloud: {
      plan: null,
      months: [],
      price: null,
    },
    cloudCartTotal: 0,
    summaryProducts: [],
    seasonalDiscount: null,
  },

  getters: {
    currentStep(state) {
      return state.currentStep;
    },
    reachedStep(state) {
      return state.reachedStep;
    },
    getCartProducts(state) {
      return state.cartProducts;
    },
    isInCartProducts: (state) => (product) => {
      return (
        state.cartProducts.find((row) => row.ID === product.ID) !== undefined
      );
    },
    cartCloud(state) {
      return state.cartCloud;
    },
    cloudPlan(state) {
      return state.cloudPlan;
    },
    cloudMonths(state) {
      return state.cloudMonths;
    },
    licenceData(state) {
      return state.licenceData;
    },
    totalProducts(state) {
      if (state.cartProducts.length > 0 || state.osPrice) {
        let os =
          state.cartProducts.filter(
            (product) => product.UWAGI === 'N_SKP' && product.key !== 'O'
          ).length !== 0
            ? 0
            : state.osPrice;
        let total =
          os +
          state.cartProducts.reduce(function (sum, item) {
            return sum + item['NETTO'];
          }, 0);

        let limitedVersion = state.cartProducts.filter(
          (item) => item.key === 'O'
        )[0];
        if (limitedVersion && state.quantity > 1) {
          total +=
            limitedVersion['NETTO'] * state.quantity - limitedVersion['NETTO'];
        }

        return total;
      } else {
        return 0;
      }
    },
    totalCloud(state) {
      if (state.cartCloud.length > 0) {
        return state.cartCloud.reduce(function (sum, item) {
          return sum + item.net;
        }, 0);
      } else {
        return 0;
      }
    },
    version(state) {
      return state.version;
    },
    payment(state) {
      return state.payment;
    },
    delivery(state) {
      return state.delivery;
    },
    summary: (state) => {
      return state;
    },
    invoiceData(state) {
      return state.invoiceData;
    },
    correspondenceData(state) {
      return state.correspondenceData;
    },
    showInvoice(state) {
      return state.showInvoice;
    },
    AKL(state) {
      return state.AKL;
    },
    os(state) {
      return state.os;
    },
    osOldPrice(state) {
      return state.osOldPrice;
    },
    osPrice(state) {
      return state.osPrice;
    },
    discounts(state) {
      return state.discounts;
    },
    discount(state) {
      return state.discount;
    },
    discountRecommendation(state) {
      return state.discountRecommendation;
    },
    discountFromRecommendationSet(state) {
      return state.discountFromRecommendationSet;
    },
    walletBalance(state) {
      return state.walletBalance;
    },
    changeLicence(state) {
      return state.changeLicence;
    },
    policy(state) {
      return state.policy;
    },
    file(state) {
      return state.file;
    },
    orderBy(state) {
      return state.orderBy;
    },
    orderSource(state) {
      return state.orderSource;
    },
    quantity(state) {
      return state.quantity;
    },
    freeCloudUsed(state) {
      return state.freeCloudUsed;
    },
    currentCloud(state) {
      return state.currentCloud;
    },
    currentCloudPlan(state) {
      return state.currentCloud.plan;
    },
    currentCloudMonths(state) {
      return state.currentCloud.months;
    },
    currentCloudPrice(state) {
      return state.currentCloud.price;
    },
    cloudCartTotal(state) {
      return state.cloudCartTotal;
    },
    summaryProducts(state) {
      return state.summaryProducts;
    },
    totalNet(state) {
      return state.totalNet;
    },
    totalGross(state) {
      return state.totalGross;
    },
    seasonalDiscount(state) {
      return state.seasonalDiscount;
    },
  },
  mutations: {
    changeStep(state, step) {
      state.currentStep = step;
    },
    incrementStep(state) {
      state.currentStep += 1;
      if (state.currentStep > state.reachedStep) {
        state.reachedStep = state.currentStep;
      }
    },
    decrementStep(state) {
      state.currentStep -= 1;
    },
    addProduct(state, product) {
      state.cartProducts.push(product);
    },
    removeProduct(state, product) {
      state.cartProducts = state.cartProducts.filter(
        (row) => row.ID !== product.ID
      );
    },
    removeProductByKey(state, key) {
      state.cartProducts = state.cartProducts.filter((row) => row.key !== key);
    },
    emptyCartProducts(state) {
      state.cartProducts = [];
    },
    updateCloud(state, month) {
      let index = state.cartCloud.findIndex((obj) => {
        return obj.monthId === month.monthId;
      });
      state.cartCloud[index] = month;
    },
    removeCloudProducts(state) {
      state.cartCloud = [];
    },
    addCloud(state, month) {
      state.cartCloud.push(month);
    },
    setLicenceData(state, value) {
      state.licenceData = value;
    },
    addVersion(state, value) {
      state.version.push(value);
    },
    removeVersion(state, value) {
      state.version = state.version.filter((row) => row !== value);
    },
    setVersion(state, value) {
      state.version = value;
    },
    setCloudPlan(state, value) {
      state.cloudPlan = value;
    },
    addCloudMonth(state, value) {
      // if (!state.cloudMonths.includes(value)) {
      state.cloudMonths.push(value);
      // }
    },
    clearCloudMonths(state) {
      state.cloudMonths = [];
    },
    setCloudMonths(state, value) {
      state.cloudMonths = value;
    },
    setPayment(state, value) {
      state.payment = value;
    },
    setDelivery(state, value) {
      state.delivery = value;
    },
    setInvoiceData(state, data) {
      state.invoiceData.nip = data.nip;
      state.invoiceData.name1 = data.name1;
      state.invoiceData.name2 = data.name2;
      state.invoiceData.address = data.address;
      state.invoiceData.postalCode = data.postalCode;
      state.invoiceData.city = data.city;
    },
    setCorrespondenceData(state, data) {
      state.correspondenceData.AKN = data.AKN;
      state.correspondenceData.AKA = data.AKA;
      state.correspondenceData.AKM = data.AKM;
    },
    setShowInvoice(state, value) {
      state.showInvoice = value;
    },
    setAKL(state, value) {
      state.AKL = value;
    },
    setOs(state, value) {
      if (
        localStorage.getItem('staffName') === 'formsoft' &&
        localStorage.getItem('staffId') === '0'
      ) {
        state.os = false;
      } else {
        state.os = value;
      }
    },
    setOsOldPrice(state, value) {
      if (
        localStorage.getItem('staffName') === 'formsoft' &&
        localStorage.getItem('staffId') === '0'
      ) {
        state.osOldPrice = null;
      } else {
        state.osOldPrice = value;
      }
    },
    setOsPrice(state, value) {
      if (
        localStorage.getItem('staffName') === 'formsoft' &&
        localStorage.getItem('staffId') === '0'
      ) {
        state.osPrice = null;
      } else {
        state.osPrice = value;
      }
    },
    addDiscount(state, discount) {
      if (state.discounts.find((i) => i.id === discount.id) === undefined) {
        state.discounts.push(discount);
      }
    },
    setDiscount(state, value) {
      state.discount = value;
    },
    setDiscountRecommendation(state, value) {
      state.discountRecommendation = value;
    },
    setDiscountFromRecommendation(state, value) {
      state.discountFromRecommendationSet = value;
    },
    setWalletBalance(state, value) {
      state.walletBalance = value;
    },
    setChangeLicence(state, value) {
      state.changeLicence = value;
    },
    setPolicy(state, value) {
      state.policy = value;
    },
    setTotalGross(state, value) {
      state.totalGross = value;
    },
    setTotalNet(state, value) {
      state.totalNet = value;
    },
    setFile(state, value) {
      state.file = value;
    },
    setOrderBy(state, value) {
      state.orderBy = value;
    },
    setOrderSource(state, value) {
      state.orderSource = value;
    },
    setQuantity(state, value) {
      state.quantity = value;
    },
    setFreeCloud(state, value) {
      state.freeCloudUsed = value;
    },
    setCurrentCloudPlan(state, value) {
      state.currentCloud.plan = value;
    },
    setCurrentCloudMonths(state, value) {
      state.currentCloud.months = value;
    },
    setCurrentCloudPrice(state, value) {
      state.currentCloud.price = value;
    },
    setCartCloudTotal(state, value) {
      state.cloudCartTotal = value;
    },
    setSummaryProducts(state, value) {
      state.summaryProducts = value;
    },
    resetSteps(state) {
      state.reachedStep = 1;
      state.currentStep = 1;
    },
    setSeasonalDiscount(state, value) {
      state.seasonalDiscount = value;
    },
    resetOrder(state) {
      state.os = true;
      state.changeLicence = null;
      state.osOldPrice = null;
      state.osPrice = null;
      state.discounts = [];
      state.discount = null;
      state.cartProducts = [];
      state.cartCloud = [];
      state.cloudPlan = null;
      state.cloudMonths = [];
      state.licenceData = {
        NIP: '',
        NAG: '',
        N1: '',
        N2: '',
        AD: '',
        KOD: '',
        MI: '',
        TEL1: '',
        TEL2: '',
        E1: '',
        O1: '',
        SIE: '',
      };
      state.version = ['e-aktu'];
      state.payment = 'transfer';
      state.delivery = null;
      state.invoiceData = {
        nip: '',
        name1: '',
        name2: '',
        address: '',
        postalCode: '',
        city: '',
      };
      state.correspondenceData = {
        AKN: '',
        AKA: '',
        AKM: '',
      };
      state.showInvoice = false;
      state.AKL = false;
      state.file = null;
      state.orderBy = null;
      state.orderSource = 'te';
      state.quantity = 1;
      state.freeCloudUsed = false;
      state.currentCloud = {
        plan: null,
        months: [],
        price: null,
      };
      state.cloudCartTotal = 0;
      state.discountRecommendation = null;
      state.discountFromRecommendationSet = true;
      state.summaryProducts = [];
      state.walletBalance = 0;
      state.policy = false;
      state.totalGross = 0;
      state.totalNet = 0;
      state.summaryProducts = [];
      state.seasonalDiscount = null;
    },
  },
};
